import axios from 'axios';
import cdnConfig from '@/config/config-cdn';

const cdnApi = axios.create({
	baseURL: cdnConfig.url,
});

export default cdnApi;
